import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../shadcn/Select";
import { communicationTypeFilters } from "../../data/selectionData";

const CommType = ({ value, onChange }) => {
  // Convert empty string to "all" for display, and convert "all" back to empty string for backend
  const displayValue = value === "" ? "all" : value;

  const handleChange = (newValue) => {
    const backendValue = newValue === "all" ? "" : newValue;
    onChange(backendValue);
  };

  return (
    <Select value={displayValue} onValueChange={handleChange}>
      <SelectTrigger>
        <SelectValue placeholder="Select type" />
      </SelectTrigger>
      <SelectContent>
        {communicationTypeFilters.map(({ name, value }) => (
          <SelectItem key={name} value={value}>
            {name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default CommType;